import { callAPIWhiteToken } from '../config/api';

const PATH_API = process.env.REACT_APP_API;

export async function postData(data: any) {
	const url = `${PATH_API}/users-store`;
	return await callAPIWhiteToken({
		url,
		method: 'POST',
		data: data,
	});
}

export async function getDataStore() {
	const url = `${PATH_API}/users-store/list`;
	return await callAPIWhiteToken({
		url,
		method: 'GET',
	});
}

export async function getDataStoreDetail(uniqueId: string) {
	const url = `${PATH_API}/users-store/unique-id/${uniqueId}`;
	return await callAPIWhiteToken({
		url,
		method: 'GET',
	});
}
